<template>
  <div name="h-full">
    <div class="modal-container d-flex flex-column h-full">
      <TopAppBar
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        :hideCategory="false"
        staticMode="true"
      ></TopAppBar>

      <div class="flex-grow-1 scroll-y">
        <TopAppBarDrawer></TopAppBarDrawer>

        <main class="main-wrapper flex-grow-1">
          <div class="container container--narrow">
            <div
              class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center"
            >
              {{ $t("3825") }}
            </div>

            <div class="mgt-30" />

            <div class="container container--narrow mdc-card">
              <div v-for="(item, i) in blockList" :key="i">
                <div class="d-flex flex-row justify-content-between pda-16">
                  <div class="d-flex flex-row">
                    <UserImgProfile :data="item.target" />

                    <div class="d-flex flex-column justify-content-center">
                      <div>
                        {{
                          $t("3437", {
                            last: item.target.name.last,
                            first: item.target.name.first,
                          })
                        }}
                      </div>
                      <div class="t-helper t-color-gray3 mgt-1">
                        {{ $moment(item.created).format("YYYY/MM/DD") }}
                        {{ $t("3826") }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-centner align-items-center t-helper t-color-signRed cursor-pointer"
                    @click="restoreBlock(item)"
                    @keypress="restoreBlock(item)"
                  >
                    {{ $t("3827") }}
                  </div>
                </div>

                <div class="divider" />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
  
<script>
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { userMixin } from "@/mixins/user";
import memberApi from "@/api/memberApi";
import { storageConstants } from "@/utils/enum/StorageConstants";

export default {
  name: "BlockUser",

  components: {
    TopAppBar: () => import("@/components/TopAppBar.vue"),
    TopAppBarDrawer: () => import("@/components/TopAppBarDrawer.vue"),
    UserImgProfile: () =>
      import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  mixins: [topAppBarMixin, userMixin],

  data() {
    return {
      blockList: null,
      bgColorOfName: localStorage.getItem(storageConstants.bgColors),
    };
  },

  mounted() {
    this.setTopAppBarHomeSearch(localStorage.getItem('brandName'));
    this.getBlockedUserList();
  },

  methods: {
    async getBlockedUserList() {
      try {
        const blockUserListResult = await memberApi.getBlockList();
        if (blockUserListResult) {
          const result = blockUserListResult.data.data;
          result.sort((a, b) => new Date(b.created) - new Date(a.created));
          this.blockList = result;
        }
      } catch (error) {
        console.log("GET BLOCK USER LIST ERROR : ", error);
      }
    },

    async restoreBlock(item) {
      try {
        const dialogResult = await this.$confirm({
          title: this.$t("3816"),
          content: this.$t("3817"),
          accept: this.$t("3818"),
          cancel: this.$t("3819"),
        });
        if (dialogResult) {
          const restoreBlockResult = await memberApi.restoreBlock(
            item.target.id
          );
          if (restoreBlockResult) {
            this.$snackOpen({
              contents: this.$t("3820", {
                str: this.$t("3437", {
                  last: item.target.name.last,
                  first: item.target.name.first,
                }),
              }),
            });
            this.getBlockedUserList();
          }
        }
      } catch (error) {
        console.log("RESTORE BLOCK ERROR : ", error);
      }
    },

    firstCharOfMemberName(name) {
      if (typeof name === "string") return name.charAt(0);
      if (name.first) {
        let fullName = this.$t("3437", { first: name.first, last: name.last });
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },

    getRandomColor() {
      let colors = [
        "#fb6262",
        "#d16443d4",
        "#4d9fd6",
        "#40bca7",
        "#9db82f",
        "#76a0d6",
        "#a967d4",
        "#696481",
        "#4c438d",
        "#fe7947",
      ];
      let randomColor = colors[Math.floor(Math.random() * colors.length)];
      //localStorage.setItem('bgColors', `background-color:${randomColor}`)
      return `background-color:${randomColor}`;
    },
  },
};
</script>
  
<style scoped>
.list-wrapper {
  margin-top: 68px;
}
</style>